export { default as CorporateCardRequestSlot } from './CorporateCardRequestSlot';
